import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { withStores } from "../../../utils/withStore";
import { inject, observer } from "mobx-react";
import { MResetPassStore } from "./store";
import { MResetPassProps } from "./type";
import { LOCATION_ORIGN, MobClsPrefix } from "../../../constants";
import { getLabel, middleware, setTitle, weappSDK } from "@weapp/utils";
import { encryptRsa, getQueryString, inApp } from "../../../utils";
import { Form, MDialog, MButton, FormDatas, MSpin, Icon } from "@weapp/ui";
import "./style/index.less";
import { runInAction } from "mobx";

const { toast, prompt } = MDialog;

const clsPrefix = `${MobClsPrefix}-resetpass`

@withStores({ mResetPassStore: new MResetPassStore() })
@inject("mResetPassStore")
@middleware('weappPassportWeb', 'MResetPass')
@observer
export class MResetPass extends React.Component<MResetPassProps & RouteComponentProps> {

  state = {
    oldPassword: "",
    oldPassVisible: false,
    passVisible: false,
    pass2Visible: false,

    showOldPass: false
  }

  componentDidMount(): void {
    const oldPassword = inApp() ? getQueryString("password") : sessionStorage.getItem("PASSPORT_RESETPASS_TRANS")
    this.setState({ oldPassword: oldPassword, showOldPass: !oldPassword });
    setTitle({ title: getLabel('154575', '修改密码') })
    this.props.mResetPassStore?.setAccount(getQueryString('account'));
    this.props.mResetPassStore?.setOldPassword(oldPassword || "");
    this.updateFormLayout();
  }

  updateFormLayout = () => {
    const { passVisible, pass2Visible, oldPassword, oldPassVisible, showOldPass } = this.state;
    this.props.mResetPassStore?.formStore.initForm({
      items: {
        passwordCheck: {
          itemType: oldPassVisible ? 'INPUT' : "PASSWORD",
          placeholder: getLabel('20815', '原密码'),
          required: true,
          otherParams: {
            allowClear: true,
            suffix: <span className={`${clsPrefix}-input-eye`}
              onClick={() => this.setState({ oldPassVisible: !oldPassVisible }, this.updateFormLayout)}>
              <Icon weId={`${this.props.weId || ''}_xa2bdt`}
                name={oldPassVisible ? `Icon-Open-password` : `Icon-Close-password`} />
            </span>
          }
        },
        newPassword: {
          itemType: passVisible ? 'INPUT' : "PASSWORD",
          required: true,
          placeholder: getLabel('16759', '新密码'),
          // placeholder: getLabel('154670','字母、数字、符号至少两种组合，不低于6位'),
          otherParams: {
            allowClear: true,
            suffix: <span className={`${clsPrefix}-input-eye`}
              onClick={() => this.setState({ passVisible: !passVisible }, this.updateFormLayout)}>
              <Icon weId={`${this.props.weId || ''}_19hvot`}
                name={passVisible ? `Icon-Open-password` : `Icon-Close-password`} />
            </span>
          }
        },
        newPasswordAgain: {
          itemType: pass2Visible ? 'INPUT' : "PASSWORD",
          required: true,
          placeholder: getLabel('154977', '密码确认'),
          otherParams: {
            allowClear: true,
            suffix: <span className={`${clsPrefix}-input-eye`}
              onClick={() => this.setState({ pass2Visible: !pass2Visible }, this.updateFormLayout)}>
              <Icon weId={`${this.props.weId || ''}_ogyvhv`}
                name={pass2Visible ? `Icon-Open-password` : `Icon-Close-password`} />
            </span>
          }
        },
        passwordStrength: {
          itemType: "CUSTOM"
        }
      },
      layout: [
        [{
          id: "passwordCheck",
          span: 24,
          wrapClassName: `${clsPrefix}-password`,
          label: getLabel('20815', '原密码'),
          hide: !showOldPass,
          items: ['passwordCheck']
        }, {
          id: "password",
          span: 24,
          wrapClassName: `${clsPrefix}-password`,
          label: getLabel('16759', '新密码'),
          items: ['newPassword'],
          hide: false
        }, {
          id: "passwordAgain",
          span: 24,
          label: getLabel('18997', '确认密码'),
          items: ['newPasswordAgain'],
          hide: false
        }]
      ],
      groups: [],
      data: this.props.mResetPassStore?.formStore.getFormDatas() || {}
    })
  }

  render(): React.ReactNode {
    const { mResetPassStore } = this.props;
    const { formStore, loading } = mResetPassStore;

    return (
      <div className={`${clsPrefix}`}>
        <MSpin weId={`${this.props.weId || ''}_9r9u87`} spinning={loading}>
          <Form weId={`${this.props.weId || ''}_nsvsyp`}
            isMobile={true}
            onChange={(data?: FormDatas) => {
              data && Object.keys(data).includes("newPassword") && mResetPassStore?.updateData({ password: data?.newPassword })
            }}
            store={formStore} />
          <MButton weId={`${this.props.weId || ''}_35klr3`}
            className={`${clsPrefix}-confirm`}
            onClick={() => {
              mResetPassStore?.submit(() => {
                sessionStorage.setItem("PASSPORT_RESETPASS_TRANS", "");
                toast({ type: "success", content: getLabel('93544', '密码修改成功') })
                setTimeout(() => {
                  if (inApp()) {
                    weappSDK.customSDK.invoke("closeWindow", {
                      success: (res: any) => {
                      }
                    })
                  } else {
                    const redirect = getQueryString("redirect");
                    if (redirect) {
                      window.location.href = decodeURIComponent(redirect);
                    } else {
                      window.history.go(-1)
                    }
                  }
                }, 3000)
              })
            }}
            type={'primary'}>
            {getLabel('12694', '确认')}
          </MButton>
        </MSpin>
      </div>
    )
  }
}

export class MResetPassUtil {
  static showResetPass(loginObj: { password: string, username: string }, redirectType?: 'back' | 'redirect') {
    //管理员重置密码强制用户修改
    let confirm: any = null;
    prompt({
      title: getLabel('154889', '请立即修改密码'),
      prompt: false,
      description: getLabel('154580', '您上次使用的是被管理员修改或重置的密码，请立即修改密码，以保障账号安全'),
      getInstance: (el: any) => {
        confirm = el;
      },
      footer: [{
        key: 'confirm',
        text: getLabel('93406', '确定'),
        type: 'primary',
        onPress: () => {
          let data = { password: loginObj.password };
          if (data.password?.length < 100) {
            data = encryptRsa(data, 'password')
          }
          sessionStorage.setItem("PASSPORT_RESETPASS_TRANS", data.password);
          if (inApp()) {
            const link = `${LOCATION_ORIGN}/passport/resetpass?redirect=${encodeURIComponent(window.location.href)}&account=${loginObj.username}&password=${data.password}`;
            weappSDK.customSDK.invoke("openLink", {
              url: link,
              openType: 2,
            });
            confirm?.onClose?.();
          } else {
            confirm?.onClose?.();
            const link = `/passport/resetpass?${redirectType === "back" ? '' : `redirect=${encodeURIComponent(window.location.href)}&`}account=${loginObj.username}`;
            window.location.href = link;
          }
        }
      }]
    })
  }
}

export default withRouter(MResetPass);